import { jsx as _jsx } from "react/jsx-runtime";
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector, useDispatch } from 'react-redux';
import { AppliedFilterRow } from '../../components/lister/deprecated/applied-filters/AppliedFilterRow';
import { I18N_NAMESPACES } from '../../constants/i18nConstants';
import { filterActions } from '../../redux/filter/actions/FilterActions.creators';
import { makeGetFlattenedActiveFiltersState } from '../../redux/filter/selectors/FilterSelectors';
export const AppliedFilterContainer = () => {
    const { t } = useTranslation(I18N_NAMESPACES.general);
    const dispatch = useDispatch();
    const flattenedActiveFilters = useSelector((state) => makeGetFlattenedActiveFiltersState()(state.filters));
    const getContentFilters = (filters) => filters.map((filter) => (Object.assign(Object.assign({}, filter), { filterOnName: t(filter.filterOnName) })));
    const activeFilters = useMemo(() => getContentFilters(flattenedActiveFilters), [flattenedActiveFilters]);
    const toggleFilter = (toggledFilter) => dispatch(filterActions.updateFilters(toggledFilter));
    const removeAllFilters = () => dispatch(filterActions.removeAllFilters());
    return (_jsx(AppliedFilterRow, { flattenedActiveFilters: activeFilters, onToggleFilter: toggleFilter, onRemoveAllFilters: removeAllFilters }));
};
